import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import { CommonService } from '@shared/services/common.service';
import storageService from '@shared/storage/storageService';
import { AddUserComponent } from '../add-user/adduser.component';
import { ImportFileComponent } from '../import-file/import-file.component';
import { ConfirmDialogComponent } from '@shared/confirm-dialog/confirm-dialog.component';
import { DownloadDialogComponent } from '@shared/components/download-dialog/download-dialog.component';

@Component({
	selector: 'user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
	data: any[];
	cols: any[];
	toggle: boolean;
	subscription: any;
	totalRecords: any;
	showSpinner: boolean = false;
	filterBy: any = "";
	visible: boolean =  true;
	DEFAULT_PAGE_NO = 0;
	DEFAULT_PAGE_SIZE = 10;
	selectedLanguage = "";
	isFilterEnable = false;
	dialogRef: any;
	constructor(
		public auth: ApiCall,
		public dialog: MatDialog,
		private router: Router,
		private commonService: CommonService,
		private broadCast: BroadCastServiceService,
		public translate: TranslateService) {
	}

	ngOnInit(): void {
		this.setLanguage();
		this.broadCast.sendMessage('superadmin_user');
		this.broadCast.sendMessage('organization');
		this.commonService.isComponent = 'superadmin_user';
		this.getAllUser();
		this.getCurrentStatus();
		this.cols = [
			{ field: 'firstName', header: 'NAME', width: "200px" },
			{ field: 'email', header: 'EMAIL_ID', width: "250px" },
			{ field: 'roles', header: 'ROLE', width: "200px" },
			{ field: 'organization', header: 'ORGANIZATION', width: "200px" },
		];
	}
	
	setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}

	openImportFile() {
		this.dialog.open(ImportFileComponent);
	}

	getAllUser() {
		try {
			this.showSpinner = true;
			this.visible = false;
			this.auth.getUserByPage(this.DEFAULT_PAGE_NO, this.DEFAULT_PAGE_SIZE).subscribe((res: any) => {
				try {
					if (res.status == 'SUCCESS') {
						this.data = res.data.data;
						this.totalRecords = res.data.totalRecords;
						this.showSpinner = false
					}
				} catch {
					this.showSpinner = false
				}
			}, (error) => {
				console.error("API error while getting users, ", error);
			}, () => {
				this.visible = true;
			})
		} catch (error) {
			console.error("Error ", error)
		}

	}

	addUser() {
		this.dialog.open(AddUserComponent, {
			position: { right: '0' },
			height: '100%',
		});
	}

	getCurrentStatus() {
		this.subscription = this.broadCast
			.getMessage()
			.subscribe((message) => {
				if (message == "getUser") {
					this.getAllUser()
				}
			});
	}

	refresh() {
		let currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
	onChange(filter) {
		try {
			this.isFilterEnable = true;
			filter = filter === "all" ? "" : filter;
			this.filterBy = filter;
			this.visible = false;	// Refreshing the table to reset the pagination
			this.auth.getUserByPage(this.DEFAULT_PAGE_NO, this.DEFAULT_PAGE_SIZE, filter).subscribe((res: any) => {
				if (res.status === "SUCCESS" && res.data.data) {
					this.data = res.data.data;
					this.totalRecords = res.data.totalRecords;
				} else {
					this.data = null;
				}
			}, (error) => {
				console.error("Error occurred while fetching users, ", error);
			}, () => {
				this.visible = true;
			});
		} catch (error) {
			console.error("Error while changing the filter value, ", error);
		}
	}

	clearFilter(event) {
		if(event.flag) {
		   this.isFilterEnable = true;
		}
	  }

	  downloadUsers() {
		try {
		  let message = [];
		  this.translate.get(['DOWNLOAD_ALL_USERS_UNDER_ORG'])
		  .subscribe(translations => {
			message = translations['DOWNLOAD_ALL_USERS_UNDER_ORG'];
		  });
		  this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
			maxWidth: "400px",
			data: {
			  title: "Download",
			  message: message,
			},
		  });
	
		  this.dialogRef.afterClosed().subscribe((yes) => {
			if (yes) {
			  this.dialogRef = this.dialog.open(DownloadDialogComponent, {
				data: {
				  title: "Download",
				  message: `Please wait while the file is being downloaded`,
				},
				maxWidth: "400px",
			  });
			}
		  });
		} catch (error) {
		  console.error("Error while downloading the users, ", error);
		}
	  } 


	
}
